import { render, staticRenderFns } from "./studentRegister.vue?vue&type=template&id=7466a04a&scoped=true&"
import script from "./studentRegister.vue?vue&type=script&lang=js&"
export * from "./studentRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7466a04a",
  null
  
)

export default component.exports